import Vue from 'vue'
import Vuex from 'vuex'
import SwaggerClient from 'swagger-client'
import { inspect } from 'util'
import { reject } from 'q';
import mixin from './mixin'

Vue.use(Vuex)
Vue.mixin(mixin)

const LOGIN = 'LOGIN'
const SSO_LOGIN = 'SSO_LOGIN'
const LOGIN_WITH_TOKEN = 'LOGIN_WITH_TOKEN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'
// 最新バージョン情報
const VERSION = '1.55.9'
const DATE_UPDATED = '2026/10/09'
// 本番リリースの為 バージョン更新 -20261008-
// url
var url = location.href;
console.log(url)
var ENV
if (url.indexOf('https://src-order.com/') != -1) {
  ENV = "production"
} else if (url.indexOf('https://qa.src-order.com') != -1) {
  ENV = "qa"
} else {
  ENV = "development"
}

export default new Vuex.Store({
  state: {
    isLoggedIn: !!sessionStorage.getItem('userInfo'),
    version: VERSION,
    dateUpdated: DATE_UPDATED,
    env: ENV,
    isSSOLogin:process.env.IS_SSO_LOGIN,
    ssoLogoutUrl: process.env.SSO_LOGOUT,
    ssoLogin:process.env.SSO_LOGIN,
  },
  mutations: {
    [LOGIN](state) {
      state.pending = true
    },
    [SSO_LOGIN](state) {
      state.pending = true
    },
    [LOGIN_WITH_TOKEN](state) {
      state.pending = true
    },
    [LOGIN_SUCCESS](state) {
      state.isLoggedIn = true
      state.pending = false
    },
    [LOGOUT](state) {
      state.isLoggedIn = false
    }
  },
  actions: {
    login({ commit }, creds) {
      commit(LOGIN) // show spinner
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.loginPOST({
            body: {
              mail: creds.mail,
              password: creds.password,
              version: VERSION,
              ssologin: false
            }
          }).then(result => {
            console.log(result)
            let userInfo = result.obj;
            sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
            var lastLoginDate = userInfo.preLoginedTimestamp;
            if (lastLoginDate == "Invalid Date") {
              lastLoginDate = "";
            }
            sessionStorage.setItem('lastLoginDate', lastLoginDate)
            commit(LOGIN_SUCCESS)
            resolve(result)
          }).catch(error => {
            resolve(error)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    ssoLogin({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.loginPOST({
            body: {
              mail: creds.mail,
              password: creds.password,
              version: VERSION,
              ssologin: true
            }
          }).then(result => {
            window.location.href = process.env.SSO_REQ;
            resolve(0)
          }).catch(error => {
            if (error != null && (error.status === 400 || error.status === 401 || error.status === 500)) {
              // サーバから返されたメッセージをダイアログ表示
              console.log(error.response.body.message)
              this._vm.showErrorMessage(error.response.body.message)
              resolve(1)
            } else {
              // "予期しないエラーが発生しました。"でダイアログを表示
              alert("予期しないエラーが発生しました。")
            }
            resolve(1)
          })
        }).catch(error => {
          // "予期しないエラーが発生しました。"でダイアログを表示
          console.log(error)
          alert("予期しないエラーが発生しました。")
          resolve(1)
        })
      })
    },
    ssoLoginInfo({ commit }, creds) {
      return new Promise(resolve => {
        commit(LOGIN) // show spinner
        fetch(process.env.SSO_INFO)
          .then(res => res.json())
          .then(data => {
          new SwaggerClient({
            url: '/api-docs',
            requestInterceptor: req => {
              if (req.body && !req.headers['Content-Type']) {
                req.headers['Content-Type'] = 'application/json'
              }
            }
          }).then(client => {
            client.apis.auth.loginPOST({
              body: {
                mail: data.email,
                otptoken: creds.otptoken || "",
                accessType: creds.accessType || "",
                version: VERSION,
                ssologin: creds.isSSOLogin
              }
            }).then(result => {
            console.log(result)
            let userInfo = result.obj;
            sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
            var lastLoginDate = userInfo.preLoginedTimestamp;
            if (lastLoginDate == "Invalid Date") {
              lastLoginDate = "";
            }
            sessionStorage.setItem('lastLoginDate', lastLoginDate)
            commit(LOGIN_SUCCESS)
            resolve(result)
          }).catch(async error => {
              if (error != null && (error.status === 400 || error.status === 401 || error.status === 500)) {
                // サーバから返されたメッセージをダイアログ表示
                console.log(error.response.body.message)
                await new Promise(resolve => {
                  this._vm.$dialog.confirm({
                    title: '　',
                    message: error.response.body.message,
                    canCancel: true,
                    confirmText: 'OK',
                    cancelText: 'ログアウト',
                    onConfirm: () => {
                      resolve();
                    },
                    onCancel: () => {
                      // ダイアログの「ログアウト」後にログアウト
                      window.location.href = process.env.SSO_LOGOUT
                    }
                  });
                });
              } else {
                // "予期しないエラーが発生しました。"でダイアログを表示
                alert("予期しないエラーが発生しました。")
              }
              // reject()
            })
          }).catch(error => {
            // "予期しないエラーが発生しました。"でダイアログを表示
            console.log(error)
            alert("予期しないエラーが発生しました。")
            resolve(1)
            // reject()
          })
        })
      })
    },


    authPassPhrase({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.authPassPhrasePOST({
            body: {
              mail: creds.mail,
              passPhrase: creds.passPhrase,
            }
          }).then(result => {
            console.log(result)
            var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            userInfo.token = result.obj.token;
            sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
            resolve(result)
          }).catch(error => {
            resolve(error)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    logout({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = JSON.parse(sessionStorage.getItem('userInfo')).token
            }
          }
        }).then(client => {
          client.apis.auth.logoutPOST({
            body: {
            }
          }).then(result => {
            console.log(result)
            sessionStorage.removeItem('userInfo');
            sessionStorage.removeItem('lastLoginDate');
            sessionStorage.removeItem('salesOfficeMaster');
            sessionStorage.removeItem('authorityMaster');
            sessionStorage.removeItem('branchOfficeMaster');
            sessionStorage.removeItem('blockMaster');
            sessionStorage.removeItem('statusMaster');
            sessionStorage.removeItem('cpapStatusMaster');
            sessionStorage.removeItem('kindMaster');
            sessionStorage.removeItem('cpapKindMaster');
            sessionStorage.removeItem('cpapKindMasterForSearch');
            sessionStorage.removeItem('cpapPatientCodeStatusMaster');
            sessionStorage.removeItem('cpapCodeMaster');
            sessionStorage.removeItem('choiceMaster');
            sessionStorage.removeItem('cpapManagementStatus');
            sessionStorage.removeItem('cpapMaster');
            sessionStorage.removeItem('cpapStandardList');
            sessionStorage.removeItem('cpapAccessoryList');
            sessionStorage.removeItem('cpapSetItemList');
            sessionStorage.removeItem('cpapChoiceMaster');
            sessionStorage.removeItem('taskList');
            sessionStorage.removeItem('taskListNotFetched');
            sessionStorage.removeItem('oneClickOrderList');
            commit(LOGOUT)
            resolve()
          }).catch(error => {
            console.log(error)
            // エラーが発生した場合もローカルストレージは破棄
            sessionStorage.removeItem('userInfo');
            sessionStorage.removeItem('lastLoginDate');
            sessionStorage.removeItem('salesOfficeMaster');
            sessionStorage.removeItem('authorityMaster');
            sessionStorage.removeItem('branchOfficeMaster');
            sessionStorage.removeItem('blockMaster');
            sessionStorage.removeItem('statusMaster');
            sessionStorage.removeItem('cpapStatusMaster');
            sessionStorage.removeItem('kindMaster');
            sessionStorage.removeItem('cpapKindMaster');
            sessionStorage.removeItem('cpapKindMasterForSearch');
            sessionStorage.removeItem('cpapPatientCodeStatusMaster');
            sessionStorage.removeItem('cpapCodeMaster');
            sessionStorage.removeItem('choiceMaster');
            sessionStorage.removeItem('cpapManagementStatus');
            sessionStorage.removeItem('cpapMaster');
            sessionStorage.removeItem('cpapStandardList');
            sessionStorage.removeItem('cpapAccessoryList');
            sessionStorage.removeItem('cpapSetItemList');
            sessionStorage.removeItem('cpapChoiceMaster');
            sessionStorage.removeItem('taskList');
            sessionStorage.removeItem('taskListNotFetched');
            sessionStorage.removeItem('oneClickOrderList');
            commit(LOGOUT)
            resolve()
          })
        }).catch(error => {
          console.log(error)
          // エラーが発生した場合もローカルストレージは破棄
          sessionStorage.removeItem('userInfo');
          sessionStorage.removeItem('lastLoginDate');
          sessionStorage.removeItem('salesOfficeMaster');
          sessionStorage.removeItem('authorityMaster');
          sessionStorage.removeItem('branchOfficeMaster');
          sessionStorage.removeItem('blockMaster');
          sessionStorage.removeItem('statusMaster');
          sessionStorage.removeItem('cpapStatusMaster');
          sessionStorage.removeItem('kindMaster');
          sessionStorage.removeItem('cpapKindMaster');
          sessionStorage.removeItem('cpapKindMasterForSearch');
          sessionStorage.removeItem('cpapPatientCodeStatusMaster');
          sessionStorage.removeItem('cpapCodeMaster');
          sessionStorage.removeItem('choiceMaster');
          sessionStorage.removeItem('cpapManagementStatus');
          sessionStorage.removeItem('cpapMaster');
          sessionStorage.removeItem('cpapStandardList');
          sessionStorage.removeItem('cpapAccessoryList');
          sessionStorage.removeItem('cpapSetItemList');
          sessionStorage.removeItem('cpapChoiceMaster');
          sessionStorage.removeItem('taskList');
          sessionStorage.removeItem('taskListNotFetched');
          sessionStorage.removeItem('oneClickOrderList');
          commit(LOGOUT)
          resolve()
        })
      })
    },
    passwordinit({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.passwordinitPOST({
            body: {
              mail: creds.mail,
              passphrase: creds.passphrase
            }
          }).then(result => {
            console.log(result)
            resolve(result)
          }).catch(error => {
            resolve(error)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    sendPassphraseForPasswordinitPOST({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.sendPassphraseForPasswordinitPOST({
            body: {
              loginmail: creds.loginmail,
              passphraseAddress: creds.passphraseAddress
            }
          }).then(result => {
            console.log(result)
            resolve(result)
          }).catch(error => {
            resolve(error)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    passwordForceChange({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = JSON.parse(sessionStorage.getItem('userInfo')).token
            }
          }
        }).then(client => {
          client.apis.auth.passwordChangePOST({
            body: {
              currentpassword: creds.currentpassword,
              newpassword: creds.newpassword
            }
          }).then(result => {
            console.log(result)
            resolve(result)
          }).catch(error => {
            console.log(error)
            resolve(error)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    sendConfirmationMail({ commit },creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.sendConfirmationMailPOST({
            body: {
              mail: creds.mail,
              apiPath: creds.apiPath,
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    sendUserAddMailPOST({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = JSON.parse(sessionStorage.getItem('userInfo')).token
            }
          }
        }).then(client => {
          client.apis.auth.sendUserAddMailPOST({
            body: {
              mail: creds.mail,
              authentication: creds.authentication,
              apiPath: creds.apiPath,
              belongsId: creds.belongsId
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    authenticationCheckPOST({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.authenticationCheckPOST({
            body: {
              authentication: creds.authentication,
              key: creds.key,
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    passPhraseAuth({ commit}, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.passPhraseAuthPOST({
            body: {
              userId: creds.id,
              passPhrase: creds.passPhrase,
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    verifyKey({ commit}, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.verifyKeyPOST({
            body: {
              key: creds.key
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    verifyKeyForRequestViewer({ commit}, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.verifyKeyForRequestViewerPOST({
            body: {
              key: creds.key
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    verifyKeyForIntroductionRequest({ commit}, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.verifyKeyForIntroductionRequestPOST({
            body: {
              key: creds.query
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    verifyKeyForIntroductionRequestAuth({ commit}, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = creds.token
            }
          }
        }).then(client => {
          client.apis.auth.verifyKeyForIntroductionRequestAuthPOST({
            body: {
              key: creds.query
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    verifyKeyForHolterPatientReportRedirect({ commit}, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.verifyKeyForHolterPatientReportRedirectPOST({
            body: {
              key: creds.query
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    getChoiceMaster({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.apiCommon.getChoicesListPOST({
            body: {}
          }).then(result => {
            sessionStorage.setItem('choiceMaster', JSON.stringify(result.obj));
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    getPrescriptionHardware({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.apiCommon.getPrescriptionHardwarePOST({
            body: {}
          }).then(result => {
            var cpapMaster = [];
            for (var i = 0; i < result.obj.length; i++) {
              cpapMaster.push({
                itemCode: result.obj[i].itemCode,
                itemName: result.obj[i].itemName,
                reportFormatType: result.obj[i].reportFormatType,
              });
            }
            sessionStorage.setItem('cpapMaster', JSON.stringify(cpapMaster));
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    getCpapStatus({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.apiCommon.getCpapStatusListPOST({
            body: {}
          }).then(result => {
            var statusMaster = [];
            for (var i = 0; i < result.obj.length; i++) {
              statusMaster.push({
                statusCode: result.obj[i].statusCode,
                statusName: result.obj[i].statusName,
                progressName: result.obj[i].progressName
              });
            }
            sessionStorage.setItem('cpapStatusMaster', JSON.stringify(statusMaster));
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    registAuth({ commit}, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.registAuthPOST({
            body: {
              id: creds.id,
              password: creds.password,
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    requestViewerAuth({ commit}, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.requestViewerAuthPOST({
            body: {
              key: creds.key,
              password: creds.password,
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    resultDownload({ commit}, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.resultDownloadAuthPOST({
            body: {
              key: creds.key,
              password: creds.password,
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    downloadFile({ commit}, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.apiCommon.getDownloadFileForResultDownLoadPOST({
            body: {
              fileName: creds.fileName,
              fileId: creds.fileId,
              key: creds.key,
              password: creds.password,
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    requestReExaminationAdjustment({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.requestReExaminationAdjustmentPOST({
            body: {
              key: creds.key,
              shortestShippingDateList: creds.shortestShippingDateList,
              selectType: creds.selectType,
              serial: creds.serial
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    registration({ commit },creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = creds.token
            }
          }
        }).then(client => {
          client.apis.auth.registrationPOST({
            body: {
              authorityCode: creds.authorityCode,
              mail: creds.mail,
              lastName: creds.lastName,
              firstName: creds.firstName,
              lastNameKana: creds.lastNameKana,
              firstNameKana: creds.firstNameKana,
              phoneNumber: creds.phoneNumber,
              passPhrase: creds.passPhrase,
              passPhone: creds.passPhone,
              passMail: creds.passMail,
              companyName: creds.companyName,
              division: creds.division,
              zip: creds.zip,
              prefecture: creds.prefecture,
              city: creds.city,
              address1: creds.address1,
              address2: creds.address2,
              agreedInfoDisclosure: creds.agreedInfoDisclosure,
              publicMail: creds.publicMail,
              branchOfficeCode: creds.branchOfficeCode,
              serviceId: creds.serviceId,
              coInUse: creds.coInUse,
              coMailAddress: creds.coMailAddress,
              usePDashboard: creds.usePDashboard,
              belongsId: creds.belongsId,
              applicantId: creds.applicantId
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    requestCo({ commit },creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = creds.token,
              req.headers['extUserId'] = creds.extUserId
            }
          }
        }).then(client => {
          client.apis.externalCO.setCoApplicationPOST({
            body: {
              belongsId: creds.belongsId,
              institutionApplication: creds.institutionApplication,
              userInfoList: creds.userInfoList
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    getAddressFromPostCode({ commit },creds){
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = creds.token
            }
          }
        }).then(client => {
          client.apis.apiCommon.getAddressFromPostCodePOST({
            body: {
              postCode:creds.postCode
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    sendTest({ commit },creds){
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = creds.token
            }
          }
        }).then(client => {
          client.apis.apiCommon.sendTestPOST({
            body: {
              contactAddress:creds.contactAddress,
              contactPhoneNumber:creds.contactPhoneNumber
            }
          }).then(result => {
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    getAnnouncement({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.apiCommon.getAnnouncementPOST({
            body: {
              type: creds.type
            }
          }).then(result => {
            console.log(result)
            resolve(result)
          }).catch(error => {
            resolve(error)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    getConsentStatement({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.apiCommon.getConsentStatementPOST({
            body: {
              type: creds.type
            }
          }).then(result => {
            console.log(result)
            resolve(result)
          }).catch(error => {
            resolve(error)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    downloadConsentStatement({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.apiCommon.downloadConsentStatementPOST({
            body: {
              type: creds.type,
              uid: creds.uid
            }
          }).then(result => {
            if(result.status == 200){
              var name = result.headers['content-disposition'].split('=')[1]
              name = name.slice(name.lastIndexOf('\'') + 1)
              const blob = result.data
              const link = document.createElement("a")
              link.href = window.URL.createObjectURL(blob)
              link.download = decodeURI(name)
              link.click()
              
            } 
            resolve(result)
          }).catch(error => {
            resolve(error.response)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    getBrunchList({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.auth.getBrunchListPOST({
            body: {}
          }).then(result => {
            resolve(result)
          }).catch(error => {
            resolve(error.response)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    getBrunchAddressList({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
              req.headers['Authorization'] = JSON.parse(sessionStorage.getItem('userInfo')).token
            }
          }
        }).then(client => {
          client.apis.auth.getBrunchAddressListPOST({
            body: {}
          }).then(result => {
            resolve(result)
          }).catch(error => {
            resolve(error.response)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    getCpapChoiceMaster({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.apiCommon.getCpapChoicesListPOST({
            body: {}
          }).then(result => {
            sessionStorage.setItem('cpapChoiceMaster', JSON.stringify(result.obj));
            resolve(result)
          }).catch(result => {
            resolve(result)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
    cancelUsePDashboard({ commit }, creds) {
      return new Promise(resolve => {
        new SwaggerClient({
          url: '/api-docs',
          requestInterceptor: req => {
            if (req.body && !req.headers['Content-Type']) {
              req.headers['Content-Type'] = 'application/json'
            }
          }
        }).then(client => {
          client.apis.internalMaintenance.cancelUsePDashboardPOST({
            body: {
              userId: creds.userId,
            }
          }).then(result => {
            console.log(result)
            resolve(result)
          }).catch(error => {
            resolve(error)
          })
        }).catch(error => {
          resolve(error)
        })
      })
    },
  }
})


// WEBPACK FOOTER //
// ./src/store.js